/** Merge under `presentations.gallery` in each locale. */
export const presentationsGalleryCopy = {
  en: {
    filters: {
      label: 'Filter presentations',
      status: 'Status',
      allStatuses: 'All statuses',
      project: 'Project',
      allProjects: 'All projects',
      updated: 'Updated',
      anyTime: 'Any time',
      last7: 'Last 7 days',
      last30: 'Last 30 days',
      last90: 'Last 90 days',
      clear: 'Clear all',
      sortBy: 'Sort by',
    },
    sort: {
      updatedDesc: 'Last updated',
      updatedAsc: 'Oldest updated',
      nameAsc: 'Name A–Z',
      nameDesc: 'Name Z–A',
    },
    view: { label: 'Layout', grid: 'Grid view', list: 'List view' },
    drafts: {
      title: 'Drafts & unfinished presentations',
      description:
        'Pick up where you left off. These are presentation drafts; template forks are managed under Templates.',
      viewAll: 'View all drafts',
      continue: 'Continue editing',
      open: 'Open',
      edited: 'Edited {{time}}',
    },
    all: {
      title: 'All presentations',
      description: 'Presentations across the projects you can reach.',
    },
    card: {
      updated: 'Updated {{time}}',
      open: 'Open',
      share: 'Share',
      shareLabel: 'Share {{name}}',
    },
    menu: { open: 'Open presentation', share: 'Share' },
    create: {
      project: 'Project',
      projectIn: 'In project {{name}}',
      projectPlaceholder: 'Choose a project',
    },
  },
  fa: {
    filters: {
      label: 'فیلتر ارائه‌ها',
      status: 'وضعیت',
      allStatuses: 'همه وضعیت‌ها',
      project: 'پروژه',
      allProjects: 'همه پروژه‌ها',
      updated: 'به‌روزرسانی',
      anyTime: 'هر زمان',
      last7: '۷ روز گذشته',
      last30: '۳۰ روز گذشته',
      last90: '۹۰ روز گذشته',
      clear: 'پاک‌کردن همه',
      sortBy: 'مرتب‌سازی',
    },
    sort: {
      updatedDesc: 'آخرین به‌روزرسانی',
      updatedAsc: 'قدیمی‌ترین به‌روزرسانی',
      nameAsc: 'نام (الف تا ی)',
      nameDesc: 'نام (ی تا الف)',
    },
    view: { label: 'چیدمان', grid: 'نمای شبکه‌ای', list: 'نمای فهرستی' },
    drafts: {
      title: 'پیش‌نویس‌ها و ارائه‌های نیمه‌تمام',
      description:
        'از همان‌جا که ماندید ادامه دهید. اینها پیش‌نویس ارائه‌اند؛ انشعاب‌های قالب در بخش قالب‌ها مدیریت می‌شوند.',
      viewAll: 'مشاهده همه پیش‌نویس‌ها',
      continue: 'ادامه ویرایش',
      open: 'باز کردن',
      edited: 'ویرایش {{time}}',
    },
    all: {
      title: 'همه ارائه‌ها',
      description: 'ارائه‌های پروژه‌هایی که به آنها دسترسی دارید.',
    },
    card: {
      updated: 'به‌روزرسانی {{time}}',
      open: 'باز کردن',
      share: 'اشتراک‌گذاری',
      shareLabel: 'اشتراک‌گذاری {{name}}',
    },
    menu: { open: 'باز کردن ارائه', share: 'اشتراک‌گذاری' },
    create: {
      project: 'پروژه',
      projectIn: 'در پروژه {{name}}',
      projectPlaceholder: 'یک پروژه انتخاب کنید',
    },
  },
} as const;
